import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { clsx } from "clsx";
import styles from "./LoopingImage.module.css";
export const LoopingImage = ({ imagePrefix, count, className, fallbackImage = "/images/empty-state-request.png", onError, }) => {
    const [useFallback, setUseFallback] = useState(false);
    // Calculate image index from count: ((count - 1) % 10) + 1
    // This ensures: count 1→image 1, count 2→image 2, ..., count 10→image 10, count 11→image 1, etc.
    const imageIndex = count === 0 ? 1 : ((count - 1) % 10) + 1;
    const handleImageError = () => {
        if (fallbackImage) {
            setUseFallback(true);
        }
        if (onError) {
            onError(new Error(`Failed to load image: ${imagePrefix}-${imageIndex}.png`));
        }
    };
    const handleImageLoad = () => {
        setUseFallback(false);
    };
    const imageSrc = useFallback
        ? fallbackImage
        : `${imagePrefix}-${imageIndex}.png`;
    return (_jsx("img", { src: imageSrc, alt: "", className: clsx(styles.image, className), onError: handleImageError, onLoad: handleImageLoad }));
};
